/* @flow */
/* eslint-env es6,browser */

import { isEmptyObject } from '../utils/coreutils';
import _idpbase from './idpbase';

export default class _multiidpbase extends _idpbase {
  _enabledProviders: Array<string>;

  // $FlowFixMe
  _cachedObj: any;

  constructor(name: string) {
    super(name);
    this._enabledProviders = [];
    this._cachedObj = {};
  }

  _reset() {
    this._cachedObj = {};
  }

  _updateConfig(o: multiIDIDPConfig) {
    super._updateConfig(o);
    const { enabledProviders = [] } = o;
    this._enabledProviders = enabledProviders;
  }

  isEnabled(idpKey: string = ''): boolean {
    return (
      super.isEnabled() &&
      idpKey.length > 0 &&
      this._enabledProviders.includes(idpKey)
    );
  }

  _shouldRefresh(): boolean {
    return isEmptyObject(this._cachedObj);
  }

  getID(idpKey: string = ''): string | Array<string> {
    let ret = '';
    if (idpKey.length === 0 || isEmptyObject(this._cachedObj)) {
      return ret;
    }
    ret = this._cachedObj[idpKey] || ret;
    return ret;
  }
}
